import { fetchCachedCatalog } from "../utils/filterCache";

export default {
  namespaced: true,

  state: {
    integrador: localStorage.getItem("integrador") || null,
    integradores: null,
    loadingIntegradores: false,
  },

  getters: {
    integrador: (state) => state.integrador,
    integradores: (state) => state.integradores,
  },

  mutations: {
    setIntegrador(state, integrador) {
      state.integrador = integrador;
      if (integrador) {
        localStorage.setItem("integrador", integrador);
      } else {
        localStorage.removeItem("integrador");
      }
    },
    setIntegradores(state, integradores) {
      let list = [];
      if (Array.isArray(integradores)) {
        list = [...integradores];
      } else if (integradores && Array.isArray(integradores.data)) {
        list = [...integradores.data];
      } else if (integradores) {
        state.integradores = integradores;
        return;
      }
      list.sort((a, b) =>
        String(a.integrador || "").localeCompare(String(b.integrador || ""), undefined, { sensitivity: "base" })
      );
      state.integradores = { data: list };
    },
    setLoadingIntegradores(state, loading) {
      state.loadingIntegradores = loading;
    },
    clearIntegradores(state) {
      state.integradores = null;
      state.integrador = null;
    },
  },

  actions: {
    fetchIntegradores({ commit, state }, force = false) {
      const token = localStorage.getItem("authToken");

      if (!token) {
        return Promise.resolve(null);
      }

      if (!force && state.integradores && state.integradores.data && state.integradores.data.length > 0) {
        return Promise.resolve(state.integradores);
      }

      if (state.loadingIntegradores) {
        return Promise.resolve(null);
      }

      commit("setLoadingIntegradores", true);
      commit("setLoading", true, { root: true });
      return fetchCachedCatalog(process.env.VUE_APP_API_URL + "integrador/list", {}, force)
        .then((response) => {
          commit("setIntegradores", response.data);
          const list = Array.isArray(response.data) ? response.data : (response.data && response.data.data);
          if (list && list.length > 0 && !localStorage.getItem("integrador")) {
            const firstId = list[0].id_integrador || list[0].id;
            commit("setIntegrador", firstId);
          }
          return response.data;
        })
        .catch((error) => {
          commit("setErrors", error, { root: true });
          throw error;
        })
        .finally(() => {
          commit("setLoadingIntegradores", false);
          commit("setLoading", false, { root: true });
        });
    },
  },
};
